import React from "react";
import Login from "./Login";

const Header = ({isAuthenticated, user, onLogin, openModal, toggleSound, isSoundOn, volume, setVolume}) => {

    return (
        <div className="title-bar">
            <div className="title-logo-div">
                <div className="title-logo1"></div>
                <div className="title-logo2"></div>
            </div>
            <Login 
            isAuthenticated={isAuthenticated} 
            user={user}
            onLogin={onLogin} 
            openModal={openModal} 
            toggleSound={toggleSound} 
            isSoundOn={isSoundOn} 
            volume={volume}
            setVolume={setVolume}
            />
        </div>
    );

}

export default Header;